/* eslint-disable react/react-in-jsx-scope */
import { useState, useRef, useEffect } from 'react';
import axios from 'axios';

// Data
const apiurl = `${process.env.REACT_APP_API}`
const imgurl = `${process.env.REACT_APP_URL}/image/products`

// const products = [
//     {
//       id: 1,
//       title: 'Cake browny',
//       price: '$129',
//       instock: '200',
//       href: '#',
//       description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//       imgUrl:'https://theunlikelybaker.com/wp-content/uploads/2017/10/Chocolate-Chiffon-Cake-Recipe-Feature.jpg',
//       date: 'Mar 16, 2020',
//       datetime: '2020-03-16',
//       category: 'Cakes',
//     },
//     {
//       id: 2,
//       title: 'chiffon-cake',
//       price: '$89',
//       instock: '159',
//       href: '#',
//       description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//       imgUrl:'https://cookingwithdog.com/wp-content/uploads/2021/03/chiffon-cake-00-1615696212.9265.jpg',
//       date: 'Mar 10, 2020',
//       datetime: '2020-03-10',
//       category: 'Chiffon',
//     },
//     {
//       id: 3,
//       title: 'Yellow Bowl Chiffon',
//       price: '$79',
//       instock: '179',
//       href: '#',
//       description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//       imgUrl:'https://assets.epicurious.com/photos/627aaf5f080d9862e3bda7d6/1:1/w_2560%2Cc_limit/PandanChiffon_RECIPE_050522_33403.jpg',
//       date: 'Mar 12, 2020',
//       datetime: '2020-03-12',
//       category: 'Bakery',
//     },
//     {
//       id: 4,
//       title: 'Cake browny',
//       price: '$109',
//       instock: '159',
//       href: '#',
//       description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//       imgUrl:'https://www.themarblekitchen.com/wp-content/uploads/2021/10/Chocolate-Brownie-Cake-1.jpg',
//       date: 'Mar 16, 2020',
//       datetime: '2020-03-16',
//       category: 'Cakes',
//     },
//     {
//       id: 5,
//       title: 'Chiffon coconut',
//       price: '$119',
//       instock: '159',
//       href: '#',
//       description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//       imgUrl:'https://zhangcatherine.com/wp-content/uploads/2022/03/12001200.jpg',
//       date: 'Mar 10, 2020',
//       datetime: '2020-03-10',
//       category: 'Chiffon',
//     },
//     {
//       id: 6,
//       title: 'Citrus-Chiffon',
//       price: '$129',
//       instock: '179',
//       href: '#',
//       description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//       imgUrl:'https://bakefromscratch.com/wp-content/uploads/2022/05/Citrus-Chiffon-312JBweb.jpg',
//       date: 'Mar 12, 2020',
//       datetime: '2020-03-12',
//       category: 'Bakery',
//     },
//     {
//       id: 7,
//       title: 'blueberry-chiffon-cake',
//       price: '$159',
//       instock: '200',
//       href: '#',
//       description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//       imgUrl:'https://teakandthyme.com/wp-content/uploads/2024/10/blueberry-chiffon-cake-DSC_2632-1x1-1200.jpg',
//       date: 'Mar 16, 2020',
//       datetime: '2020-03-16',
//       category: 'Cakes',
//     },
//     {
//       id: 8,
//       title: 'browny Choce',
//       price: '$179',
//       instock: '200',
//       href: '#',
//       description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//       imgUrl:'https://www.tasteofhome.com/wp-content/uploads/2018/01/exps164_MC163887B03_10_24b.jpg',
//       date: 'Mar 10, 2020',
//       datetime: '2020-03-10',
//       category: 'Chiffon',
//     },
//     {
//       id: 9,
//       title: 'Box4-Chiffon',
//       price: '$179',
//       instock: '200',
//       href: '#',
//       description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//       imgUrl:'https://down-id.img.susercontent.com/file/709385c8df2fb4c8ee3050dc4ba84c52',
//       date: 'Mar 12, 2020',
//       datetime: '2020-03-12',
//       category: 'Bakery',
//     },
//     {
//       id: 10,
//       title: 'BirthDay-chiffon-cake',
//       price: '$159',
//       instock: '200',
//       href: '#',
//       description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//       imgUrl:'https://down-id.img.susercontent.com/file/dcb34b2ef6fd04941a85432da9dd6d11',
//       date: 'Mar 16, 2020',
//       datetime: '2020-03-16',
//       category: 'Cakes',
//     },
//     {
//       id: 11,
//       title: 'Coffee Mocha',
//       price: '$179',
//       instock: '200',
//       href: '#',
//       description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//       imgUrl:'https://images.tokopedia.net/img/cache/500-square/VqbcmM/2021/3/18/ef0914b3-1016-474f-8829-ca599832d4d5.jpg',
//       date: 'Mar 10, 2020',
//       datetime: '2020-03-10',
//       category: 'Chiffon',
//     },
//     {
//       id: 12,
//       title: 'Matcha-Chiffon',
//       price: '$179',
//       instock: '200',
//       href: '#',
//       description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//       imgUrl:'https://www.siftandsimmer.com/wp-content/uploads/2022/10/matcha-chiffon-cake-featured.jpg',
//       date: 'Mar 12, 2020',
//       datetime: '2020-03-12',
//       category: 'Bakery',
//     },
//     {
//     id: 13,
//       title: 'Chocolate Icing',
//       price: '$179',
//       instock: '200',
//       href: '#',
//       description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//       imgUrl:'https://www.pholfoodmafia.com/wp-content/uploads/2018/05/1000x650ChocolateChiffonCakewithChocolateIcing-590x418.jpg',
//       date: 'Mar 10, 2020',
//       datetime: '2020-03-10',
//       category: 'Chiffon',
//     },
//     {
//       id: 14,
//       title: 'fruit-Chiffon',
//       price: '$179',
//       instock: '200',
//       href: '#',
//       description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//       imgUrl:'https://www.deliciousmagazine.co.uk/wp-content/uploads/2023/04/S2023D103_SEO_CHIFFON_3__-768x960.jpg',
//       date: 'Mar 12, 2020',
//       datetime: '2020-03-12',
//       category: 'Bakery',
//     },
//     {
//       id: 15,
//       title: 'Coconut Chiff',
//       price: '$179',
//       instock: '200',
//       href: '#',
//       description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//       imgUrl:'https://i.ytimg.com/vi/eBDzexQK9XU/maxresdefault.jpg',
//       date: 'Mar 12, 2020',
//       datetime: '2020-03-12',
//       category: 'Bakery',
//     },
//     {
//       id: 16,
//       title: 'Lemon Meringue',
//       price: '$179',
//       instock: '200',
//       href: '#',
//       description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//       imgUrl:'https://domesticdreamboat.com/wp-content/uploads/2022/04/Lemon-Meringue-Chiffon-Cake-Cut-cropped.jpg',
//       date: 'Mar 12, 2020',
//       datetime: '2020-03-12',
//       category: 'Bakery',
//     },
//     // More posts...
// ]


const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const carousel = useRef(null);
  const [products, setProducts] = useState([]);

  const fetchRecommend = async () => {
    // setLoading(true);
    // setReportType(period);
    try {
        const result = await axios.get(`${apiurl}/products.php?mode=getrecommend`);
        
        // console.log(result);
        if(result.data && result.data[0].length>0) {  
          setProducts(result.data[0]);
        }
    } catch (error) {
        console.error('Error fetching summary:', error);
    }
    // setLoading(false);
  };

  useEffect(() => {
    
    fetchRecommend();

  },[])


  const movePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevState) => prevState - 1);
    } 
  };

  const moveNext = () => {
    const maxwidth = carousel.current.scrollWidth - carousel.current.offsetWidth;
    // console.log(maxwidth);
    if (
      carousel.current !== null &&
      carousel.current.offsetWidth * currentIndex <= maxwidth
    ) {
      setCurrentIndex((prevState) => prevState + 1);
    } else {
      setCurrentIndex(0);
    }
  };

//   useEffect(() => {
//     const  slideInterval = setInterval(moveNext, 10000)

//     return () => clearInterval(slideInterval)
// }, [])


  useEffect(() => {
    if (carousel !== null && carousel.current !== null) {
      carousel.current.scrollLeft = carousel.current.offsetWidth * currentIndex;
    }
  }, [currentIndex]);

  return (
    <div className="max-w-7xl px-4 mt-4 my-4 mx-auto">
      <h2 className="text-2xl leading-8 font-semibold mb-2 text-slate-300">
        สินค้าแนะนำ
        <button onClick={movePrev} type="button" className="relative inline-block top-0 left-0 z-10  items-center justify-center h-full px-2 cursor-pointer group focus:outline-none" data-carousel-prev>
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/30 dark:bg-gray-500/30 group-hover:bg-white/50 dark:group-hover:bg-gray-500/60  dark:group-focus:ring-gray-800/70 group-focus:outline-none">
                <svg className="w-4 h-4 text-white dark:text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1 1 5l4 4"/>
                </svg>
                <span className="sr-only">Previous</span>
            </span>
        </button>
        <button onClick={moveNext} type="button" className="relative inline-block top-0 right-0 z-10 items-center justify-center h-full px-1 cursor-pointer group focus:outline-none" data-carousel-next>
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/30 dark:bg-gray-500/30 group-hover:bg-white/50 dark:group-hover:bg-gray-500/60  dark:group-focus:ring-gray-800/70 group-focus:outline-none">
                <svg className="w-4 h-4 text-white dark:text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
                </svg>
                <span className="sr-only">Next</span>
            </span>
        </button>
      </h2>
      <div className="max-w-7xl overflow-hidden">
        <div
          ref={carousel}
          className="relative flex gap-1 overflow-hidden w-full scroll-smooth snap-x snap-proximity touch-pan-x z-0"
        >
          {products?.map((resource, index) => {
            return (
              <div
                key={index}
                className="relative text-center snap-start w-36 h-36"
              >
                <div
                  href={resource.name}
                  className="h-full w-full rounded-xl aspect-square block z-0"
                  // style={{ backgroundImage: `url(${imgurl}/${resource.img})`}}
                >
                  <img
                    src={`${imgurl}/${resource.img}`}
                    alt={resource.name}
                    className="h-full w-full rounded-xl "
                  />
                </div>
                <button
                  // href={resource.name}
                  className="h-full w-full rounded-xl aspect-square block absolute top-0 left-0 transition-opacity duration-300 opacity-0 hover:opacity-100 bg-blue-800/75 z-10"
                >
                  <h3 className="text-white py-6 px-3 mx-auto text-xl">
                    {resource.name}
                  </h3>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Carousel;